import * as ymaps3 from 'ymaps3';
import {cities, markers} from './constatns';
import {fadeIn, fadeOut} from '../utils/common';
import {storage, StorageType} from '../storage';

class PartnersMap {
  #mapContainerElement;
  #showLocationModalButtonElement;
  #locationModalElement;
  #partnersListElement;
  #partnersItemElements;

  #currentCity = `Санкт-Петербург`;

  #map;

  #isModalVisible = false;

  constructor() {
    this.#mapContainerElement = document.querySelector(`.js-partners-map-container`);

    if (!this.#mapContainerElement) return;

    this.onShowLocationModalButtonClick = this.onShowLocationModalButtonClick.bind(this);
    this.onLocationModalClick = this.onLocationModalClick.bind(this);

    this.#init().then();
  }

  async #init() {
    this.#showLocationModalButtonElement = this.#mapContainerElement.querySelector(`.js-partners-show-loc`);
    this.#locationModalElement = this.#mapContainerElement.querySelector(`.js-partners-map-modal`);
    this.#partnersListElement = this.#mapContainerElement.querySelector(`.js-partners-list`);
    this.#partnersItemElements = Array.from(this.#partnersListElement.children);

    this.#showLocationModalButtonElement.addEventListener(`click`, this.onShowLocationModalButtonClick);
    this.#locationModalElement.addEventListener(`click`, this.onLocationModalClick);

    await this.#yaMapInit();

    this.#setInitialCurrentUserLocation();
  }

  /**
   * Устанавливаем текущую локацию
   */
  #setInitialCurrentUserLocation() {
    let location = storage(StorageType.LOCAL).get(`location`);

    if (!location) return;

    location = JSON.parse(location);

    if (!location.city) return;
    if (!cities[location.city]) return;
    if (location.city === this.#currentCity) return;

    this.#setNewCity(location.city);
  }

  async #yaMapInit() {
    await ymaps3.ready;

    const {YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker} = ymaps3;

    this.#map = new YMap(
      document.getElementById('partners-map'),
      {
        location: {
          center: [30.314997, 59.948784],
          zoom: 10,
        },
      },
      [
        new YMapDefaultSchemeLayer({}),
        new YMapDefaultFeaturesLayer({}),
      ],
    );

    markers.forEach((marker) => {
      const markerElement = document.createElement('img');
      markerElement.className = 'partners-page__marker';
      markerElement.src = `/img/icons/icon-marker.svg`;
      markerElement.width = 67;
      markerElement.height = 94;
      markerElement.title = marker.address;
      markerElement.onclick = () => {
        this.#changeMapPosition({center: marker.coordinates, zoom: 15}, 1000);
      };
      this.#map.addChild(new YMapMarker({coordinates: marker.coordinates}, markerElement));
    });
  }

  #closeModal() {
    fadeOut(this.#locationModalElement, 200);
    this.#isModalVisible = false;
  }

  #setCurrentCityName(name) {
    this.#showLocationModalButtonElement.textContent = name;
  }

  /**
   *
   * @param {number?} duration
   * @param {Object} location
   * @param {number[]} location.center - координаты
   * @param {number} location.zoom - зум
   */
  #changeMapPosition(location, duration = 4000) {
    this.#map.update({location: {...location, duration}});
  }

  /**
   * Фильтрация пунктов.
   *
   * @param {boolean?} isShow - показать или скрыть элементы партнеров
   */
  #filterPartnersItem(isShow) {
    const items = this.#partnersItemElements.filter((el) => el.dataset.city === this.#currentCity);

    if (!items || items.length === 0) return;

    items.forEach((item) => {
      if (isShow) {
        item.classList.remove(`partners-page__item--hidden`);
      } else {
        item.classList.add(`partners-page__item--hidden`);
      }
    });
  }

  #setNewCity(city) {
    const {zoom, center, declination} = cities[city];

    this.#filterPartnersItem();

    this.#changeMapPosition({zoom, center});
    this.#setCurrentCityName(declination);
    this.#currentCity = city;

    this.#filterPartnersItem(true);
  }

  onShowLocationModalButtonClick() {
    !this.#isModalVisible ? fadeIn(this.#locationModalElement, 200, `flex`) : fadeOut(this.#locationModalElement, 200);
    this.#isModalVisible = !this.#isModalVisible;
  }

  onLocationModalClick(evt) {
    const target = evt.target;

    if (target.classList.contains(`js-partners-map-modal-close`)) {
      this.#closeModal();
      return;
    }

    if (target.classList.contains(`js-location-list-item`)) {
      const cityName = target.dataset.city;

      this.#setNewCity(cityName);
      this.#closeModal();
    }
  }
}

export {PartnersMap};
